'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoFilmMarker = function IoFilmMarker(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.8 16.3c0.7 0 1.2 0.5 1.2 1.1v16.4c0 0.7-0.5 1.2-1.2 1.2h-30c-0.8 0-1.3-0.5-1.3-1.2v-16.4c0-0.6 0.5-1.1 1-1.1-0.1-0.2-0.2-0.4-0.3-0.6l-0.7-3.5c-0.2-0.6 0.4-1.3 1-1.4l28.9-5.8c0.6-0.2 1.3 0.3 1.4 0.9l0.7 3.6c0.2 0.7-0.3 1.3-0.9 1.4l-26.7 5.4h26.9z m-11.2 15.1l-1.6-4.5 4-2.8h-4.8l-1.6-4.6-1.5 4.6h-4.9l4 2.8-1.5 4.5 3.9-2.8z' })
        )
    );
};

exports.default = IoFilmMarker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/film-marker.js
// module id = 2259
// module chunks = 0